import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactDOM from 'react-dom';

import * as apiConstant from '../api/apiConstant';
import bannerApi from "../api/bannerApi";
import { Pages } from '../config/Helper';
import store from '../store/configureStore';
import { addNotification } from "../actions/notificationAction";

/****************************************
    Component for Middle Banner of a page
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/
class MiddleBanner extends Component {

    constructor(props) {
        super(props);
        this.state = {
            backIndex: 0,
            back_img_urls: [],
            back_img_url: '',
            title: '',
            sub_title: ''
        }

        this.getBanner = this.getBanner.bind(this);
    }

    componentWillMount() {
        this.getBanner();
    }

    componentDidMount() {
        window.bannerTimer = setInterval(() => {
            if (this.state.backIndex + 1 >= this.state.back_img_urls.length) this.setState({ backIndex: 0 })

            else this.setState({
                backIndex: this.state.backIndex + 1
            })
        }, 5000)
    }

    componentWillUnmount() {
        clearInterval(window.bannerTimer)
    }

    componentWillReceiveProps(newProps) {
        this.getBanner();
    }

    getBanner() {
        bannerApi.getBanner(Pages.indexOf(this.props.page), this.props.orders).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    backIndex: 0,
                    back_img_urls: json.data,
                    back_img_url: json.data[0].file_path,
                    title: json.data[0].title,
                    sub_title: json.data[0].description,
                });
                return;
            } else if (json.status !== 200) {
                store.dispatch(addNotification('Server error', 'error'));
            }
            ReactDOM.findDOMNode(this.refs.middle_banner_container).style.backgroundColor = "#7249fb";
        })
    }

    render() {

        var banner_back_url = 'none';
        let back_img_url = this.state.back_img_urls[this.state.backIndex]

        // if (this.state.back_img_url.length > 0 ) {
        //     banner_back_url = `url('${apiConstant.bannerURL(this.state.back_img_url)}')`;
        // }
        if (back_img_url) {
            banner_back_url = `url('${apiConstant.bannerURL(back_img_url.file_path)}')`;
        }
        return (
            <section className="ftco-intro img bg-image overlay" id="hotel-section"
                ref="middle_banner_container"
                style={{ backgroundImage: banner_back_url }}>
                <div className="overlay"></div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-9 text-center">
                            <h2 dangerouslySetInnerHTML={{ __html: this.state.title === undefined || this.state.title === null ? '' : this.state.title }} />
                            <p dangerouslySetInnerHTML={{ __html: this.state.sub_title === undefined || this.state.sub_title === null ? '' : this.state.sub_title }} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default connect(mapStateToProps)(MiddleBanner);